import { Sprout } from "lucide-react";

const ITEMS = [
  "Balai Desa Adalah Rumah Kita Bersama",
  "Kesejahteraan Tanpa Batas",
  "Ruang Ekspresi Tanpa Diskriminasi",
  "Jaga Malam 24/7 Siaga Dusun",
  "Cianjay Harmonis & Kekinian",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((t, i) => (
      <span key={i} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-serif italic text-lg sm:text-xl text-[#F4EFE6]/90">{t}</span>
        <Sprout size={16} className="text-gold shrink-0" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="marquee-banner" className="relative z-10 bg-forest py-4 border-y border-forest overflow-hidden">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);
